<template>
    <div 
        class="w-full mx-auto" 
        :class="{
            'max-w-[1164px]': size === 'lg',
            'max-w-[1024px]': size === 'md',
            'max-w-[848px]': size === 'sm',
            'max-w-[768px]': size === 'xl-3',
            'max-w-[648px]': size === 'x-sm',
            'max-w-[600px]': size === 'x-between-sm',
            'max-w-[448px]': size === 'xx-sm',
        }"
    >
        <slot />
    </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'md',
    },
  },
};
</script>

